import React from "react";

import { cn } from "@/utils/cn";

type SelectVariant = "default" | "pill";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children: Iterable<React.ReactNode>;
  variant?: SelectVariant;
  ref?: React.Ref<HTMLSelectElement>;
}

const selectBaseClassName =
  "truncate bg-background text-foreground focus:border-primary-500 focus:outline-hidden focus:ring-1 focus:ring-primary-500 disabled:opacity-50";

const selectVariantClassName: Record<SelectVariant, string> = {
  default:
    "w-full rounded-md border border-border py-2 pl-3 pr-10 text-base sm:text-sm",
  pill: "w-auto rounded-full border border-border py-1 pl-3 pr-8 text-sm font-medium",
};

/** Full-width default variant class, kept exported for existing consumers. */
export const selectClassName = cn(
  selectBaseClassName,
  selectVariantClassName.default,
);

/** Styled `<select>` dropdown. `variant="pill"` renders the compact pill form. */
const Select = (props: SelectProps) => {
  const {
    children,
    className,
    variant = "default",
    ref,
    ...filteredProps
  } = props;

  return (
    <select
      ref={ref}
      className={cn(
        selectBaseClassName,
        selectVariantClassName[variant],
        className,
      )}
      {...filteredProps}
    >
      {children}
    </select>
  );
};

export default Select;
